import React from 'react';
import styled, { css, keyframes } from 'styled-components';

// Animation
const animation = () => keyframes`
  from {background: #fff} to {background: #000}
`;

// Styles
const LoaderWrap = styled.div<{ size?: number }>`
  display: block;
  position: relative;
  width: ${({ size }) => (size ? (size * 35) : 35)}px;
  height: ${({ size }) => (size ? (size * 35) : 35)}px;
  margin: 10px auto;
  flex: 1;
`;
const Inner = styled.div<{ size?: number, count?: string }>`
  width: ${({ size }) => ((size && size >= 2) ? 3 : 1.5)}px;
  height: ${({ size }) => (size ? size * 8 : 8)}px;
  background: #fff;
  position: absolute;
  left: 49.5%;
  top: 39%;
  border-radius: 12px;
  animation: ${animation} 1s linear infinite;
  ${({ count }) => count === 'one' && css`
    transform: rotate(-330deg) translate(0px, -142%);
    animation-delay: -0.916s;
  `}
  ${({ count }) => count === 'two' && css`
    transform: rotate(-300deg) translate(0px, -142%);
    animation-delay: -0.833s;
  `}
  ${({ count }) => count === 'three' && css`
    transform: rotate(-270deg) translate(0px, -142%);
    animation-delay: -0.75s;
  `}
  ${({ count }) => count === 'four' && css`
    transform: rotate(-240deg) translate(0px, -142%);
    animation-delay: -0.666s;
  `}
  ${({ count }) => count === 'five' && css`
    transform: rotate(-210deg) translate(0px, -142%);
    animation-delay: -0.583s;
  `}
  ${({ count }) => count === 'six' && css`
    transform: rotate(-180deg) translate(0px, -142%);
    animation-delay: -0.5s;
  `}
  ${({ count }) => count === 'seven' && css`
    transform: rotate(-150deg) translate(0px, -142%);
    animation-delay: -0.416s;
  `}
  ${({ count }) => count === 'eight' && css`
    transform: rotate(-120deg) translate(0px, -142%);
    animation-delay: -0.333s;
  `}
  ${({ count }) => count === 'nine' && css`
    transform: rotate(-90deg) translate(0px, -142%);
    animation-delay: -0.25s;
  `}
  ${({ count }) => count === 'ten' && css`
    transform: rotate(-60deg) translate(0px, -142%);
    animation-delay: -0.166s;
  `}
  ${({ count }) => count === 'eleven' && css`
    transform: rotate(-30deg) translate(0px, -142%);
    animation-delay: -0.083s;
  `}
  ${({ count }) => count === 'twelve' && css`
    transform: rotate(-0deg) translate(0px, -142%);
    animation-delay: 0s;
  `}
`;

// Interfaces
interface ILoader {
  className?: string
  size?: number
}

// Component
const Loader = (props: ILoader) => {
  const {
    className,
    size,
  } = props;

  return (
    <LoaderWrap className={className} size={size}>
      <Inner size={size} count="one" />
      <Inner size={size} count="two" />
      <Inner size={size} count="three" />
      <Inner size={size} count="four" />
      <Inner size={size} count="five" />
      <Inner size={size} count="six" />
      <Inner size={size} count="seven" />
      <Inner size={size} count="eight" />
      <Inner size={size} count="nine" />
      <Inner size={size} count="ten" />
      <Inner size={size} count="eleven" />
      <Inner size={size} count="twelve" />
    </LoaderWrap>
  );
};

// DefaultProps
Loader.defaultProps = {
  className: '',
  size: 1,
};

export default Loader;
